import QLOLogoMark from '../assets/QLOLogoMark.png';
import { ReactComponent as PhoneIcon } from '../assets/phone.svg';
import { ReactComponent as MailIcon } from '../assets/mail.svg';
import { EMAIL_ADD, LOCATION_ADD, PHONE, PHONE_NUMBER} from './constants'


export default function Footer(){
    return(
        <div className="bg-black text-white px-10 py-14">
            <div className="max-w-7xl mx-auto grid grid-cols-1 md:grid-cols-2 gap-10 text-center md:text-left">
                <div className="flex flex-col items-center md:items-start space-y-4">
                    <img
                        src={QLOLogoMark}
                        alt="QLO Logo"
                        className="w-72"
                    />
                    <p className="text-sm leading-relaxed">
                        An independent, full-service law firm in Cebu City, Philippines,
                        we deliver competent, professional, and ethical legal services to
                        ensure client satisfaction. With years of experience, we continue to
                        expand our presence locally and internationally.
                    </p>
                    <div className="mt-5 flex gap-3">
                        <a
                            href='https://facebook.com/quilatonlawoffice'
                            target="_blank"
                            rel="noopener noreferrer"
                            className="text-white text-xs py-2 px-4 border rounded-full hover:text-black hover:bg-white transition"
                        >
                            f
                        </a>
                        <a
                            href='https://linkedin.com/in/atty-abelardo-quilaton-jr-5a3b25248/'
                            target="_blank"
                            rel="noopener noreferrer"
                            className="text-white text-xs py-2 px-4 border rounded-full hover:text-black hover:bg-white transition"
                        >
                            in
                        </a>
                    </div>
                </div>

                <div className="flex flex-col items-center md:items-start space-y-3">
                    <h3 className="font-semibold text-xl">Contact Info</h3>
                    <p className="text-sm">{LOCATION_ADD}</p>
                    <div className="flex items-center gap-2">
                        <PhoneIcon className="w-5 h-5" aria-hidden="true" />
                        <a href={`tel:${PHONE}`} className="text-sm">
                        : {PHONE_NUMBER}
                        </a>
                    </div>
                    <div className="flex items-center gap-2">
                        <MailIcon className="w-5 h-5" aria-hidden="true" />
                        <a href={`mailto:${EMAIL_ADD}`} className="text-sm">
                        : {EMAIL_ADD}
                        </a>
                    </div>
                </div>
            </div>
        </div>

    )
}